import { LogoDevee } from './LogoDevee'

export default LogoDevee
